import axios from 'axios';
import { wrapAxiosInstance } from '../cache/modules/axiosFactory';
import { setupAuthInterceptor, retryWithBackoff } from '../common';
import { NAMESPACES } from '../configuration';
const BASE_URL = NAMESPACES.configuration_api.roles;

// Helper function to configure the Axios instance
const api = setupAuthInterceptor(axios.create({
  baseURL: BASE_URL,
  headers: {
    'Content-Type': 'application/json'
  }
}));

// Cached API wrapper
const cachedApi = wrapAxiosInstance(api, {
  namespace: 'configuration_api',
  group: 'roles',
  defaultTtl: '1h',
  hashLargeSegments: true,
  emitMeta: true,
});


// Function to fetch all roles
export const getAllRoles = async () => {
  return await retryWithBackoff(() =>
    cachedApi.get('/GetAllRoles')
  );
};

// GetRoleById

export const getRoleById = async (role_id: number) => {
  return await retryWithBackoff(() =>
    cachedApi.get(`/GetRoleById/${role_id}`)
  );
};
